import { createRouter } from '@tanstack/react-router';
import { rutaCambiarPassword } from './cambiar-password.js';
import { rutaElegirRol } from './elegir-rol.js';
import { rutaContabilidad } from './_contabilidad.js';
import { rutaInicioContabilidad } from './_contabilidad/inicio.js';
import { rutaDireccion } from './_direccion.js';
import { rutaEgresos } from './_egresos.js';
import { rutaRegistroEgreso } from './_egresos/egresos.js';
import { rutaCortesias } from './_egresos/cortesias.js';
import { rutaCompras } from './_egresos/compras.js';
import { rutaInicioDireccion } from './_direccion/inicio.js';
import { rutaUsuarios } from './_direccion/usuarios.js';
import { rutaUmashi } from './_direccion/umashi.js';
import { rutaCategorias } from './_direccion/categorias.js';
import { rutaCatalogo } from './_direccion/catalogo.js';
import { rutaCosteoReceta } from './_direccion/costeo-receta.js';
import { rutaGastosFijos } from './_direccion/gastos-fijos.js';
import { rutaValidacionCompras } from './_direccion/validacion-compras.js';
import { rutaSocios } from './_direccion/socios.js';
import { rutaParametrosCaja } from './_direccion/parametros-caja.js';
import { rutaDiasApertura } from './_direccion/dias-apertura.js';
import { rutaPuntoEquilibrio } from './_direccion/punto-equilibrio.js';
import { rutaTablero } from './_direccion/tablero.js';
import { rutaCobros } from './_contabilidad/cobros.js';
import { rutaAnulaciones } from './_contabilidad/anulaciones.js';
import { rutaCierrePeriodo } from './_contabilidad/cierre-periodo.js';
import { rutaCortesiasDelMes } from './_contabilidad/cortesias-mes.js';
import { rutaCuentasPorPagar } from './_contabilidad/cuentas-por-pagar.js';
import { rutaProveedores } from './_contabilidad/proveedores.js';
import { rutaConciliacion } from './_contabilidad/conciliacion.js';
import { rutaCajaAhorro } from './_contabilidad/caja-ahorro.js';
import { rutaTesoreria } from './_contabilidad/tesoreria.js';
import { rutaPasivosNoche } from './_contabilidad/pasivos-noche.js';
import { rutaImpuestosCompras } from './_contabilidad/impuestos-compras.js';
import { rutaNomina } from './_contabilidad/nomina.js';
import { rutaColaboradores } from './_contabilidad/colaboradores.js';
import { rutaResultados } from './_contabilidad/resultados.js';
import { rutaLibroMovimientos } from './_contabilidad/libro-movimientos.js';
import { rutaRetenciones } from './_contabilidad/retenciones.js';
import { rutaSaldosApertura } from './_direccion/saldos-apertura.js';
import { rutaIndice } from './indice.js';
import { rutaIngresar } from './ingresar.js';
import { rutaOperacion } from './_operacion.js';
import { rutaCierre } from './_operacion/cierre.js';
import { rutaConteo } from './_operacion/conteo.js';
import { rutaConteoInventario } from './_operacion/conteo-inventario.js';
import { rutaFaltantes } from './_operacion/faltantes.js';
import { rutaCajaMenor } from './_operacion/caja-menor.js';
import { rutaInicioOperacion } from './_operacion/inicio.js';
import { rutaPropinas } from './_operacion/propinas.js';
import { rutaReapertura } from './_operacion/reapertura.js';
import { rutaNoches } from './_operacion/noches.js';
import { rutaEfectivo } from './_operacion/efectivo.js';
import { rutaVentasUmashi } from './_operacion/ventas-umashi.js';
import { rutaVentas } from './_operacion/ventas.js';
import { rutaRaiz } from './raiz.js';

/**
 * Los tres grupos no tienen ruta propia: `_operacion`, `_contabilidad` y `_direccion` son
 * rutas sin `path`, que es lo que les permite envolver hijos con direcciones que no
 * comparten prefijo (`/jornada/conteo` cuelga de `_operacion`). La consecuencia es que
 * **el grupo no es visitable**, y el guardián manda a `/operacion`, `/contabilidad` y
 * `/direccion`. De ahí `inicio.tsx` en cada grupo: son las tres direcciones a las que se
 * llega al entrar, y sin ellas toda redirección del guardián cae en `notFound`.
 *
 * `rutaUsuarios` la agrega la tarea 19, igual que la fase 2 agrega las tres del operario.
 *
 * LA CORTESIA Y SU ACUMULADO SON DOS RUTAS EN DOS GRUPOS, y lo agrega la tarea 30. No es una
 * pantalla partida por comodidad: `app.registrar_cortesia` admite a los cuatro roles y
 * `rep.cortesias_mes` exige `jefe_operarios`, `contador` o `administrador`, asi que el operario
 * que registra la cortesia recibe un 42501 si consulta el acumulado. Publicos distintos, guardias
 * distintos, rutas distintas.
 *
 * LAS ANULACIONES Y EL CIERRE DE MES LOS AGREGA LA TAREA 23 DE LA FASE 5, y son las dos ultimas
 * pantallas de esa fase que llevaban desde la tarea 21 construidas y sin ruta. El bloque de esa
 * tarea decia que `rutaContabilidad` «hoy no tiene ninguno» hijo, y eso era cierto cuando se
 * escribio: cuando le llego el turno ya tenia cuatro, porque las fases 6 y 7 se construyeron
 * antes. Los dos van en este grupo porque el conjunto de roles de sus escenarios cabe en el suyo,
 * que es lo unico que decide, y no porque el tema se parezca.
 *
 * `_egresos` es el CUARTO grupo, y lo agrega la tarea 28 de la fase 7. Existe porque el registro de
 * un egreso lo hacen los cuatro roles y ninguno de los otros tres grupos los admite a todos:
 * `_contabilidad` exige nivel 3 y deja fuera al operario, que es quien registra el gasto de caja
 * menor, y `_operacion` exige `jornada.abrirCerrar`, que la contadora no tiene.
 *
 * LA HOJA DE CONTEO FISICO DE INVENTARIO LA AGREGA LA TAREA 21 DE LA FASE 8, en `_operacion`, porque
 * el escenario dice que la registra el operario.
 *
 * EL COSTEO POR RECETA LO AGREGA LA TAREA 22, en `_direccion`, porque con esa cifra se fija el precio
 * de carta y fijarlo es del administrador. `rep.f_costo_receta` le contesta 42501 al operario.
 *
 * LAS COMPRAS Y EL CATALOGO LOS AGREGA LA TAREA 24, y son tres rutas en dos grupos. Registrar y pagar
 * una compra, `/compras`, va en `_egresos`, porque `compra.registrar` son los cuatro roles; la bandeja
 * de validacion, `/compras/validacion`, y el catalogo, `/catalogo`, van en `_direccion`, porque validar
 * es solo del administrador y el saldo del catalogo le contesta cero al operario. El bloque ponia todo
 * en `_operacion` como `/jornada/compras`, que deja fuera a la contadora.
 */
const arbol = rutaRaiz.addChildren([
  rutaIndice,
  rutaIngresar,
  rutaCambiarPassword,
  rutaElegirRol,
  rutaOperacion.addChildren([
    rutaInicioOperacion,
    rutaVentas,
    rutaPropinas,
    rutaConteo,
    rutaCierre,
    rutaReapertura,
    rutaNoches,
    rutaEfectivo,
    rutaVentasUmashi,
    rutaFaltantes,
    rutaCajaMenor,
    rutaConteoInventario,
  ]),
  rutaContabilidad.addChildren([
    rutaInicioContabilidad,
    rutaCobros,
    rutaCortesiasDelMes,
    rutaCuentasPorPagar,
    rutaProveedores,
    rutaCategorias,
    rutaConciliacion,
    rutaTesoreria,
    rutaPasivosNoche,
    rutaImpuestosCompras,
    rutaNomina,
    rutaColaboradores,
    rutaResultados,
    rutaLibroMovimientos,
    rutaRetenciones,
    rutaCajaAhorro,
    rutaAnulaciones,
    rutaCierrePeriodo,
  ]),
  rutaDireccion.addChildren([
    rutaInicioDireccion,
    rutaUsuarios,
    rutaUmashi,
    rutaGastosFijos,
    rutaCosteoReceta,
    rutaValidacionCompras,
    rutaCatalogo,
    rutaSocios,
    rutaSaldosApertura,
    rutaParametrosCaja,
    rutaDiasApertura,
    rutaPuntoEquilibrio,
    rutaTablero,
  ]),
  rutaEgresos.addChildren([rutaRegistroEgreso, rutaCortesias, rutaCompras]),
]);

/**
 * El contexto arranca sin sesión y `main.tsx` lo actualiza con `router.update` cada vez
 * que el estado de Auth cambia. Así el `beforeLoad` de cada grupo lee un dato fresco sin
 * que ninguna ruta tenga que consultarlo por su cuenta.
 */
export const router = createRouter({
  routeTree: arbol,
  context: { sesion: null },
  // SIN PRECARGA POR INTENCIÓN, y la razón está medida contra el despliegue real. Estuvo en
  // `'intent'` desde la fase 1, pero hasta el 2026-09-28 la aplicación no tenía un solo `<Link>`,
  // así que esa precarga nunca se ejecutó en ninguna prueba ni en producción. El día que llegó
  // el menú, cada toque en un enlace dejó en consola
  // `Cannot read properties of undefined (reading '_nonReactive')` desde `preloadRoute`: en
  // `@tanstack/router-core` 1.171.15, si la navegación termina antes que la precarga, la
  // precarga busca una entrada que ya se limpió, y esa rama de `loadRouteMatch` no tiene la
  // guarda que sí tiene la de al lado. La pantalla cargaba igual; el error era ruido en cada
  // toque. La versión siguiente reescribió ese módulo entero, así que actualizar era cambiar de
  // motor en medio del despliegue. Apagarla devuelve el router al comportamiento exacto que
  // validan todas las pruebas, y cuesta un fragmento de pocos kilobytes que baja al tocar en vez
  // de al apoyar el dedo.
  // ponytail: sin precarga; volver a `'intent'` cuando el router se actualice y el recorrido de
  // `docs/despliegue.md` no deje errores en consola.
  defaultPreload: false,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
